import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";

export default function ChatReports() {
  return (
    <>
      <Navbar />
      <div className="page-container">
        <div className="card" style={{ padding: 30 }}>
          <h2>Chat Reports</h2>
          <p style={{ color: "#666", marginTop: 12 }}>Coming soon — chat reports and analytics will appear here.</p>
        </div>
      </div>
    </>
  );
}
